import $ from 'gridstrap/lib/gs-zepto';

export class GSDataService {
	private data = {};

	set(id, data) {
		this.data[id] = data;
	}

	async get(selector = 'global') {
		if (!selector) return {};
		return selector.indexOf(',') >= 0
			? await this.getAll(selector)
			: await this.getItem(selector)
		;
	}

	private async getAll(selectors) {
		let obj = {};

		for (let selector of selectors.split(/, */g)) {
			const data: any = await this.get(selector);
			obj = { ...obj, ...data };
		}

		return obj;
	}

	private getItem(selector) {
		// Syntax: selectorId[param=value](/fallback/url#target-id)
		const pattern = /([a-z0-9]+)(\[([a-z][a-z0-9_]*)=([^\]]+)\])?(\(([a-z0-9/-]+)\#([a-z-]+)\))?/im;
		const [, id, param, key, value, fallback, path, target ] = selector.match(pattern);

		return new Promise(resolve => {
			if (!param) return resolve(this.data[id] || {});

			const data = (this.data[id] || []).find(item => item[key] == value);
			// SC-648: a miss with no fallback page still answers with the key it was
			// asked for, so `products[id=9102]` opens a dialog that posts product 9102.
			if (data || !fallback) return resolve(data || { [key]: value });

			$['get'](path, html => {
				const json = $(html).filter(`[data-gs-data-id="${target}"]`).text();
				resolve(json && JSON.parse(json));
			});
		});

	}
}
